import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    TextField,
} from '@deere/fuel-react';
import React, { useContext, useState } from 'react';
import styles from '../../pages/Admin/ActiveJobDetails.module.css';
import { DateTime } from 'luxon';
import { useParams } from 'react-router-dom';
import { LoggedInContext } from '../../context/LoggedInContext';
import { errorBannerFromResponse } from '../../utils/errorBanner';

export const WithdrawEmployeeBidModal = (props) => {
    const [isWithdrawButtonClicked, setIsWithdrawButtonClicked] =
        useState(false);
    const params = useParams();
    const [notes, setNotes] = useState('');
    const [notesIsDirty, setNotesIsDirty] = useState(false);
    const [errorText, setErrorText] = useState('');
    const { makeRequest } = useContext(LoggedInContext);

    const isNotesValid = (value) => {
        if (!/^\s*$/.test(value)) {
            setNotesIsDirty(true);
            setErrorText('');
        } else {
            setNotesIsDirty(false);
        }
        return value;
    };

    const notesHandler = (event) => {
        setNotes(event.target.value);
        isNotesValid(event.target.value);
    };

    const closeWithdrawModal = () => {
        setIsWithdrawButtonClicked(false);
        setNotes('');
        setNotesIsDirty(false);
    };
    const openWithdrawModal = () => {
        setIsWithdrawButtonClicked(true);
        setNotes('');
        setNotesIsDirty(true);
        setErrorText('');
    };
    const saveHandler = async () => {
        try {
            if (notesIsDirty === true && notes !== '') {
                props.bidderObj.notes = notes;
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(props.bidderObj),
                };

                const response = await makeRequest(
                    process.env.REACT_APP_API_ENDPOINT +
                        '/job/' +
                        params.jobNumber +
                        '/withdrawBidder',
                    requestOptions
                );

                if (response.status === 200) {
                    const withdrawResponse = await response.json();
                    setIsWithdrawButtonClicked(false);
                    props.withdrawnBid(props.bidderObj.racf);
                    props.updateJobBidList(withdrawResponse);
                } else {
                    setErrorText(
                        errorBannerFromResponse(
                            response,
                            'This bid was not withdrawn. Please try again later.'
                        ).message
                    );
                    props.withdrawnBid(null);
                }
            } else {
                setErrorText(
                    'You must enter notes that explain why you are withdrawing this employees bid'
                );
                setNotesIsDirty(false);
            }
        } catch (err) {
            setErrorText(
                errorBannerFromResponse(
                    err,
                    'This bid was not withdrawn. Please try again later.'
                ).message
            );
            props.withdrawnBid(null);
        }
    };

    return (
        <>
            <Modal
                open={isWithdrawButtonClicked}
                onClose={closeWithdrawModal}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="xs"
                fullWidth={true}
            >
                <ModalTitle id="alert-Modal-title">
                    Withdraw Employee Bid
                </ModalTitle>
                <ModalContent>
                    <b>{props.bidderObj.name}</b>
                    <br />
                    Current Unit: {props.bidderObj.unit}
                    <br />
                    Current Department:{' '}
                    {props.bidderObj.department ?? props.bidderObj.dept}
                    <br />
                    Seniority Date:{' '}
                    {props.bidderObj.seniorityDate
                        ? DateTime.fromISO(
                              props.bidderObj.seniorityDate
                          ).toFormat('LL/dd/yy')
                        : ''}
                    <br />
                    <br />
                    <TextField
                        id="notes"
                        required={true}
                        label="Notes"
                        type="text"
                        placeholder={'Notes'}
                        multiline
                        minRows={3}
                        value={notes}
                        onChange={notesHandler}
                        helperText={errorText}
                        error={!notesIsDirty}
                    />
                </ModalContent>
                <ModalActions>
                    <Button onClick={closeWithdrawModal} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={saveHandler} variant="primary">
                        Save
                    </Button>
                </ModalActions>
            </Modal>

            <Button
                variant="secondary"
                onClick={openWithdrawModal}
                className={styles.pageLevelButton}
            >
                Withdraw Bid
            </Button>
        </>
    );
};

WithdrawEmployeeBidModal.defaultProps = {
    updateJobBidList: () => {},
};
